export function Footer () {
return (
    <footer>
    <div class="footer-content">
        <h2>John Ho · Des Moines, WA</h2>
        <h2><a href="mailto:jho0000rm@gmail.com"><u>jho0000rm@gmail.com</u></a> · 206-460-2681</h2>
            <div class="icons">
                <a href="mailto:jho0000rm@gmail.com"><img src="/img/Email.png" alt="Email" /></a>
                <a href="https://www.linkedin.com/in/jho0000/"><img src="/img/Linkedin.png" alt="LinkedIn" /></a>
                <a href="https://github.com/jho0000"><img src="/img/Github.png" alt="GitHub" /></a>
                <a href="https://read.cv/jho0000"><img src="/img/Resume.png" alt="Resume" /></a>
            </div>
    </div>
    </footer>
    )
}